import { AppNS } from 'app';
import { useAuthStore as authStore } from 'app/core/store_v2/auth';
import { can } from 'app/helpers/can';

import { QueryClient } from '@tanstack/react-query';

export const updateCompanyInEmploymentCache = (company: AppNS.Company, queryClient: QueryClient): void => {
  const queryKey = ['user-employments', company.ownerId];
  const previousState = queryClient.getQueryData(queryKey) as AppNS.Employment[];

  if (!previousState) {
    return;
  }

  const currentState = previousState.map((item: AppNS.Employment) => {
    if (item.companyId === company.id) {
      return { ...item, company, companyName: company.name };
    }
    return item;
  });
  queryClient.setQueryData(queryKey, currentState);
};

export const checkIsViewerOwner = (company: AppNS.Company | undefined, user: AppNS.User | undefined): boolean => {
  if (!company) {
    return false;
  }

  return user?.id === company.ownerId;
};

export const canViewerEdit = (company: AppNS.Company | undefined): boolean => {
  if (!company) {
    return false;
  }
  const { currentUser } = authStore();

  if (checkIsViewerOwner(company, currentUser as unknown as AppNS.User)) {
    return true;
  }

  return can(currentUser as unknown as AppNS.User, 'manage_company_profile', company.id);
};
